import React, { useState } from "react";
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
  sortCaret,
} from "../../Utility/Utility";
import "../style.css";
import trashImage from "images/trash.png";
import BootstrapTable from "react-bootstrap-table-next";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import ErrorModal from "./ErrorModal.js";
import { deleteRowItemData, setEinvItemErrorData } from "../action";
import { errorToastMessage } from "utils/errorToast";

const ItemListModal = ({
  openItemModal,
  setOpenItemModal,
  handleItemList,
  itemError,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { itemListData } = useSelector((state) => state.EinvReducerNew);

  const handleFileDelete = async (row) => {
    const txnID = row["0|txn_id|Txn_id"];
    const ItemTxnID = row["0|item_txn_id|Item_txn_id"];

    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you want to delete the record?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      if (itemError != 1 && itemError != 2 && itemError != 3) {
        await dispatch(deleteRowItemData(txnID, ItemTxnID));
        handleItemList(row);
      } else {
        errorToastMessage("Could not delete, it is already IRN generated.");
      }
    }
  };

  const handleError = async (row) => {
    try {
      const errorData = row["0|item_error|item_error"];
      if (!errorData) {
        console.log("No error data found for row", row);
        return;
      }

      const error = JSON.parse(errorData);
      const arrayError = Object.entries(error).map(([key, value]) => ({
        header: key.substring(8),
        error: value,
      }));
      dispatch(setEinvItemErrorData(arrayError));
      setOpen(true);
    } catch (error) {
      console.log(`Error in handleError: ${error}`);
    }
  };

  const columns = [
    // {
    //   dataField: "Delete",
    //   text: "Delete",
    //   style: (cell, row, rowIndex, colIndex) => ({
    //     ...commonStyle,
    //   }),
    //   headerStyle: {
    //     ...commonHeaderStyle,
    //     width: "1.2%",
    //   },
    //   formatter: (cell, row) => {
    //     return (
    //       <img
    //         src={trashImage}
    //         onClick={() => handleFileDelete(row)}
    //         alt="delete"
    //         style={{ width: "24px", cursor: "pointer" }}
    //       />
    //     );
    //   },
    // },
    {
      dataField: "0|txn_id|Txn_id",
      text: "Txn id",
      sort: true,
      sortCaret,
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) => displayNullFormatter(row, "0|txn_id|Txn_id"),
    },
    {
      dataField: "0|item_txn_id|Item_txn_id",
      sort: true,
      sortCaret,
      text: "Item txn id",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "0|item_txn_id|Item_txn_id"),
    },
    {
      dataField: "0|item_error|item_error",
      text: "Item Error",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "2%",
      },
      formatter: (cell, row) => {
        // return (
        //   {row["0|item_error|item_error"] != "{}" ?
        //   <Button
        //     onClick={
        //       row["0|item_error|item_error"] != "{}"
        //         ? () => handleError(row)
        //         : null
        //     }
        //     type="submit"
        //     variant="contained"
        //     color="primary"
        //     style={{
        //       backgroundColor:
        //         row["0|item_error|item_error"] != "{}" ? "#4f2d7f" : "gray",
        //       color: "white",
        //       height: "22px",
        //       fontSize: "11px",
        //       textTransform: "capitalize",
        //       cursor:
        //         row["0|item_error|item_error"] != "{}"
        //           ? "pointer"
        //           : "not-allowed",
        //     }}
        //   >
        //     Error
        //   </Button>}
        // );
        return (
          <>
            {row["0|item_error|item_error"] != "{}" ? (
              <Button
                onClick={
                  row["0|item_error|item_error"] != "{}"
                    ? () => handleError(row)
                    : null
                }
                style={{
                  backgroundColor: "#ff0000ab",
                  position: "inherit",
                  fontSize: "9px",
                  outline: "none",
                  fontFamily: "Gt-Walsheim-medium",
                }}
              >
                <span style={{ color: "#ffffffdb" }}>Item_Errors</span>
              </Button>
            ) : (
              <Button
                // onClick={() => this.viewError(cell, row, rowIndex, formatExtraData)}
                style={{
                  backgroundColor: "lightgreen",
                  position: "inherit",
                  fontSize: "9px",
                  outline: "none",
                  fontFamily: "Gt-Walsheim-medium",
                }}
              >
                <span style={{ color: "#ffffffdb" }}>No Errors</span>
              </Button>
            )}
          </>
        );
      },
    },
    {
      dataField: "85|ItemListSlNo|Sl_No",
      sort: true,
      sortCaret,
      text: "Sl No",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "85|ItemListSlNo|Sl_No"),
    },
    {
      dataField: "86|ItemListPrdDesc|Item_Description",
      sort: true,
      sortCaret,
      text: "Item Description",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "86|ItemListPrdDesc|Item_Description"),
    },
    {
      dataField: "87|ItemListIsServc|Is_Service",
      sort: true,
      sortCaret,
      text: "Is Service",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "87|ItemListIsServc|Is_Service"),
    },
    {
      dataField: "88|ItemListHsnCd|HSN_Code",
      sort: true,
      sortCaret,
      text: "HSN Code",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "88|ItemListHsnCd|HSN_Code"),
    },
    {
      dataField: "89|ItemListBarcde|Barcode",
      sort: true,
      sortCaret,
      text: "Barcode",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "89|ItemListBarcde|Barcode"),
    },
    {
      dataField: "90|ItemListQty|Quantity",
      sort: true,
      sortCaret,
      text: "Quantity",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "90|ItemListQty|Quantity"),
    },
    {
      dataField: "91|ItemListFreeQty|Free_Qty",
      sort: true,
      sortCaret,
      text: "Free Qty",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "91|ItemListFreeQty|Free_Qty"),
    },
    {
      dataField: "92|ItemListUnit|UOM",
      sort: true,
      sortCaret,
      text: "UOM",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "92|ItemListUnit|UOM"),
    },
    {
      dataField: "93|ItemListUnitPrice|Rate",
      sort: true,
      sortCaret,
      text: "Rate",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "93|ItemListUnitPrice|Rate"),
    },
    {
      dataField: "94|ItemListTotAmt|Gross_Amount",
      sort: true,
      sortCaret,
      text: "Gross Amount",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "94|ItemListTotAmt|Gross_Amount"),
    },
    {
      dataField: "95|ItemListDiscount|Discount_Amount",
      sort: true,
      sortCaret,
      text: "Discount Amount",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "95|ItemListDiscount|Discount_Amount"),
    },
    {
      dataField: "96|ItemListPreTaxVal|Pre_Tax_Value",
      sort: true,
      sortCaret,
      text: "Pre Tax Value",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "96|ItemListPreTaxVal|Pre_Tax_Value"),
    },
    {
      dataField: "97|ItemListAssAmt|Taxable_Value",
      sort: true,
      sortCaret,
      text: "Taxable Value",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "97|ItemListAssAmt|Taxable_Value"),
    },
    {
      dataField: "98|ItemListGstRt|GST_Rate",
      sort: true,
      sortCaret,
      text: "GST Rate",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "98|ItemListGstRt|GST_Rate"),
    },
    {
      dataField: "99|ItemListIgstAmt|IGST_Amt",
      sort: true,
      sortCaret,
      text: "IGST Amt",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "99|ItemListIgstAmt|IGST_Amt"),
    },
    {
      dataField: "100|ItemListCgstAmt|CGST_Amt",
      sort: true,
      sortCaret,
      text: "CGST Amt",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "100|ItemListCgstAmt|CGST_Amt"),
    },
    {
      dataField: "101|ItemListSgstAmt|SGST_Amt",
      sort: true,
      sortCaret,
      text: "SGST Amt",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "101|ItemListSgstAmt|SGST_Amt"),
    },
    {
      dataField: "102|ItemListCesRt|Cess_Rate",
      sort: true,
      sortCaret,
      text: "Cess Rate",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "102|ItemListCesRt|Cess_Rate"),
    },
    {
      dataField: "103|ItemListCesAmt|Cess_Amt_Ad_Valorem",
      sort: true,
      sortCaret,
      text: "Cess Amt Ad Valorem",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "103|ItemListCesAmt|Cess_Amt_Ad_Valorem"),
    },
    {
      dataField: "104|ItemListCesNonAdvlAmt|Cess_Non_Ad_Valorem",
      sort: true,
      sortCaret,
      text: "Cess Non Ad Valorem",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayCommaFormatter(
          row,
          "104|ItemListCesNonAdvlAmt|Cess_Non_Ad_Valorem"
        ),
    },
    {
      dataField: "105|ItemListStateCesRt|State_Cess_Rate",
      sort: true,
      sortCaret,
      text: "State Cess Rate",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },
      formatter: (cell, row) =>
        displayNullFormatter(row, "105|ItemListStateCesRt|State_Cess_Rate"),
    },
    {
      dataField: "106|ItemListStateCesAmt|State_Cess_Ad_Valorem",
      sort: true,
      sortCaret,
      text: "State Cess Ad Valorem",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayCommaFormatter(
          row,
          "106|ItemListStateCesAmt|State_Cess_Ad_Valorem"
        ),
    },
    {
      dataField: "107|ItemListStateCesNonAdvlAmt|State_Cess_Non_Ad_Valorem",
      sort: true,
      sortCaret,
      text: "State Cess Non Ad Valorem",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayCommaFormatter(
          row,
          "107|ItemListStateCesNonAdvlAmt|State_Cess_Non_Ad_Valorem"
        ),
    },
    {
      dataField: "108|ItemListOthChrg|Other_Charges",
      sort: true,
      sortCaret,
      text: "Other Charges",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayCommaFormatter(row, "108|ItemListOthChrg|Other_Charges"),
    },
    {
      dataField: "109|ItemListOrdLineRef|Purchase_Order_Line_Reference",
      sort: true,
      sortCaret,
      text: "Purchase Order Line Reference",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(
          row,
          "109|ItemListOrdLineRef|Purchase_Order_Line_Reference"
        ),
    },
    {
      dataField: "110|ItemListTotItemVal|Item_Total",
      sort: true,
      sortCaret,
      text: "Item Total",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "110|ItemListTotItemVal|Item_Total"),
    },
    {
      dataField: "111|ItemListOrgCntry|Origin_Country_Code",
      sort: true,
      sortCaret,
      text: "Origin Country Code",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "111|ItemListOrgCntry|Origin_Country_Code"),
    },
    {
      dataField: "112|ItemListPrdSlNo|Unique_Serial_Number",
      sort: true,
      sortCaret,
      text: "Unique Serial Number",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "112|ItemListPrdSlNo|Unique_Serial_Number"),
    },
    {
      dataField: "124|ItemListBchDtlsNm|Batch_Name",
      sort: true,
      sortCaret,
      text: "Batch Name",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "124|ItemListBchDtlsNm|Batch_Name"),
    },
    {
      dataField: "125|ItemListBchDtlsExpDt|Batch_Expiry_Date",
      sort: true,
      sortCaret,
      text: "Batch Expiry Date",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "125|ItemListBchDtlsExpDt|Batch_Expiry_Date"),
    },
    {
      dataField: "126|ItemListBchDtlsWrDt|Warranty_Date",
      sort: true,
      sortCaret,
      text: "Warranty Date",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "126|ItemListBchDtlsWrDt|Warranty_Date"),
    },
    {
      dataField: "127|ItemListAttribDtlsNm|Attribute_Name",
      sort: true,
      sortCaret,
      text: "Attribute Name",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "127|ItemListAttribDtlsNm|Attribute_Name"),
    },
    {
      dataField: "128|ItemListAttribDtlsVal|Attribute_Value",
      sort: true,
      sortCaret,
      text: "Attribute Value",
      style: commonStyle,
      headerStyle: { ...commonHeaderStyle, width: "2.63%" },

      formatter: (cell, row) =>
        displayNullFormatter(row, "128|ItemListAttribDtlsVal|Attribute_Value"),
    },
  ];

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openItemModal}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"Item List"}</Typography>
            <CloseIcon
              onClick={() => setOpenItemModal(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          {itemListData?.length > 0 ? (
            <div id="table-wrapperItem">
              <div id="table-scrollItem">
                <BootstrapTable
                  keyField="txn_id"
                  data={itemListData}
                  columns={columns}
                  rowStyle={rowStyle2}
                />
              </div>
            </div>
          ) : (
            <div className="no-data-div">
              <Typography variant="h6" style={{ fontWeight: "800" }}>
                No items present for this record
              </Typography>
            </div>
          )}
        </MuiDialogContent>
      </Dialog>
      <ErrorModal open={open} setOpen={setOpen} />
    </>
  );
};

export default ItemListModal;
